import OperatingHours from "./OperatingHours.js";
export default {
  install: molten => {
    molten.addPlugin('Molten.blueprintRelationshipProcessor', {
      id: 'operatingHours.routes',
      type: 'operatingHours.routes',
      processRelationship: OperatingHours
    });
  }
};